import React from "react";
import {useNavigate} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";

export default function Footer() {
    let navigate = useNavigate();

    // Venue app authenticates via Auth0 (OAuth), so use Auth0's own login
    // signal here. The localStorage access-token check used elsewhere is NOT
    // set by the Auth0 flow, so it would wrongly report logged-out on
    // authenticated pages and leak the Terms/Privacy/copyright footer.
    const {isAuthenticated} = useAuth0();
    const loggedIn = isAuthenticated;

    return (

        <footer className="bg-white dark:bg-gray-900">
            <div className="mx-auto max-w-7xl overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
                {/* Terms & Privacy live in the menu once logged in; only show
                    them in the footer on public (logged-out) pages. */}
                {!loggedIn &&
                <nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
                    {/*{navigation.main.map((item) => (*/}
                    {/*<div key="About" className="px-5 py-2">*/}
                    {/*    <a href="#" className="text-base text-gray-500 hover:text-gray-900">*/}
                    {/*        About*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                    {/*<div key="Blog" className="px-5 py-2">*/}
                    {/*    <a href="#" className="text-base text-gray-500 hover:text-gray-900">*/}
                    {/*        Blog*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                    <div key="Terms" className="px-5 py-2">
                        <span className="cursor-pointer text-base text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:underline"
                              onClick={() => {
                                  navigate('/terms');
                              }}
                        >
                            Terms
                        </span>
                    </div>
                    <div key="Privacy" className="px-5 py-2">
                        <span className="cursor-pointer text-base text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:underline"
                              onClick={() => {
                                  navigate('/privacy');
                              }}
                        >
                            Privacy
                        </span>
                    </div>
                    {/*<div key="Report" className="px-5 py-2">*/}
                    {/*    <span className="cursor-pointer text-base text-gray-500 hover:text-gray-900 hover:underline"*/}
                    {/*          onClick={() => {*/}
                    {/*              navigate('/reportproblem');*/}
                    {/*          }}*/}
                    {/*    >*/}
                    {/*        Report Problem*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                    {/*<div key="Request" className="px-5 py-2">*/}
                    {/*    <span className="cursor-pointer text-base text-gray-500 hover:text-gray-900 hover:underline"*/}
                    {/*          onClick={() => {*/}
                    {/*              navigate('/requestlocation');*/}
                    {/*          }}*/}
                    {/*    >*/}
                    {/*        Request Location*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                    {/*{!loggedIn && <div key="Login" className="px-5 py-2">*/}
                    {/*    <span className="cursor-pointer text-base text-green-700 hover:text-green-800 hover:underline"*/}
                    {/*          onClick={() => {*/}
                    {/*              navigate('/login');*/}
                    {/*          }}*/}
                    {/*    >*/}
                    {/*        Already RichestIn?*/}
                    {/*    </span>*/}
                    {/*</div>}*/}
                    {/*{loggedIn && <div key="EditRP" className="px-5 py-2">*/}
                    {/*    <span*/}
                    {/*        className="cursor-pointer text-base text-green-700 hover:text-green-900 hover:underline"*/}
                    {/*        onClick={() => {*/}
                    {/*            navigate('/edit');*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        Edit RichestIn Profile*/}
                    {/*    </span>*/}
                    {/*</div>}*/}
                    {/*{loggedIn ? <div key="Logout" className="px-5 py-2">*/}
                    {/*    <span*/}
                    {/*        onClick={() => {*/}
                    {/*        logOutSession().then(() => {*/}
                    {/*            setIsLoggedIn(false);*/}
                    {/*        })}}*/}
                    {/*        className="cursor-pointer text-base text-red-700 hover:text-red-900 hover:underline">*/}
                    {/*        RichestIn Logout*/}
                    {/*    </span>*/}
                    {/*</div> : <div key="Login" className="px-5 py-2">*/}
                    {/*    <span*/}
                    {/*        className="cursor-pointer text-base text-gray-500 hover:text-gray-900 hover:underline"*/}
                    {/*        onClick={() => {*/}
                    {/*            navigate('/login');*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        RichestIn Login*/}
                    {/*    </span>*/}
                    {/*</div>}*/}
                    {/*/!*))}*!/*/}
                </nav>
                }
                {/*<div className="mt-8 flex justify-center space-x-6">*/}
                {/*    {navigation.social.map((item) => (*/}
                {/*        <a key={item.name} href={item.href} className="text-gray-400 hover:text-gray-500">*/}
                {/*            <span className="sr-only">{item.name}</span>*/}
                {/*            <item.icon className="h-6 w-6" aria-hidden="true"/>*/}
                {/*        </a>*/}
                {/*    ))}*/}
                {/*</div>*/}
                {!loggedIn &&
                    <p className="mt-8 text-center text-base text-gray-400 dark:text-gray-500">&copy; 2026 Push Enterprise Technologies LLC.
                        All rights
                        reserved.</p>
                }
            </div>
        </footer>
    )
}
